import { xEnsureFloat64 } from "../x/index.js";
/**
 * Converts both x and y arrays to Float64Array if they are not already.
 * @param data - object containing x and y arrays.
 * @returns data with x and y as Float64Array.
 */
export function xyEnsureFloat64(data) {
    return {
        x: xEnsureFloat64(data.x),
        y: xEnsureFloat64(data.y),
    };
}
//# sourceMappingURL=xyEnsureFloat64.js.map